import { Empty } from "antd";
import StopChequeCard from "../stopChequebook";
import { useTranslation } from "react-i18next";


export default function StopChequeListItem({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <StopChequeCard record={option} />
          ))}
        </div>
      )}
    </>
  );
}
